(() => {
  // Normaliza URLs de CDN (https://…, sin ?width=…)
  const normalizeImgUrl = (u) =>
    (u || '')
      .replace(/^\/\//, 'https://')
      .replace(/([?&])width=\d+(&|$)/, '$1')
      .replace(/[?&]$/, '');

  // Normaliza URLs de video (también vienen con //)
  const normalizeVideoUrl = (u) =>
    (u || '').replace(/^\/\//, 'https://');

  // Arma el texto con títulos + numeración y marca [VIDEO]
  function buildMessage(title, items) {
    const total = items.length;
    const lines = ['Te comparto el producto:'];
    items.forEach((m, i) => {
      const ix = i + 1;
      const tag = m.kind === 'video' ? ' [VIDEO]' : '';
      lines.push(`• ${title} (${ix}/${total})${tag}`);
      lines.push(m.url);
    });
    return lines.join('\n');
  }

  // Recolecta imágenes y videos de la galería del quick-view
  function collectMedia(root) {
    const out = [];

    // Todas las slides visibles en el carrusel principal
    const slides = Array.from(
      root.querySelectorAll('.m-product-media--slider__images .swiper-slide')
    );

    if (!slides.length) return out;

    // Poner primero la slide activa
    const active = root.querySelector('.m-product-media--slider__images .swiper-slide-active');
    const ordered = [
      ...(active ? [active] : []),
      ...slides.filter(s => s !== active),
    ];

    for (const slide of ordered) {
      const type = slide.getAttribute('data-media-type'); // "image" | "video" | …
      if (type === 'image') {
        const media = slide.querySelector('.m-product-media[data-media-src]');
        const u = normalizeImgUrl(media?.dataset?.mediaSrc);
        if (u && !out.find(x => x.url === u)) out.push({ url: u, kind: 'image' });
      } else if (type === 'video') {
        // videos vienen dentro de <deferred-media><template>…<source src="//...mp4">
        const tmpl = slide.querySelector('deferred-media template');
        if (tmpl && tmpl.content) {
          const src = tmpl.content.querySelector('source[src]')?.getAttribute('src');
          const u = normalizeVideoUrl(src);
          if (u && !out.find(x => x.url === u)) out.push({ url: u, kind: 'video' });
        } else {
          // fallback: a veces el template no se clona al DOM; intenta leer el poster y saltar
          const poster = slide.querySelector('img[src]');
          const u = normalizeImgUrl(poster?.getAttribute('src'));
          if (u && !out.find(x => x.url === u)) out.push({ url: u, kind: 'image' });
        }
      }
      if (out.length >= 8) break; // límite prudente
    }

    // Fallback duro si no logró nada (tomar <img> grandes)
    if (!out.length) {
      const imgs = Array.from(root.querySelectorAll('.m-product-media--slider__images img[src]'));
      for (const img of imgs) {
        const u = normalizeImgUrl(img.currentSrc || img.src || '');
        if (u && !out.find(x => x.url === u)) out.push({ url: u, kind: 'image' });
        if (out.length >= 8) break;
      }
    }

    return out;
  }

  async function handleShare(ev) {
    const btn = ev.target.closest('.js-share-whatsapp');
    if (!btn) return;
    ev.preventDefault();

    const root = btn.closest('[data-view="quick-view"]') || document;
    // 1) Título desde la ruta que me diste
    const titleEl = root.querySelector('.m-product-quickview .m-product-info--wrapper .m-product-title a');
    const title = (titleEl?.textContent || document.title || 'Prestia').trim();

    // 2) Medios (imágenes + videos)
    const media = collectMedia(root);
    if (!media.length) {
      alert('No encontré medios para compartir.');
      return;
    }

    // 3) Intentar compartir como archivos (Android/Chrome)
    try {
      const files = await Promise.all(
        media.map(async (m, i) => {
          const res = await fetch(m.url, { mode: 'cors' });
          const blob = await res.blob();
          const ext = (blob.type.split('/')[1] || (m.kind === 'video' ? 'mp4' : 'jpg')).replace('+xml','');
          return new File([blob], `prestia-${String(i+1).padStart(2,'0')}.${ext}`, { type: blob.type });
        })
      );

      if (navigator.canShare && navigator.canShare({ files })) {
        await navigator.share({
          files,
          title,
          text: title,
        });
        return;
      }
    } catch(e) {
      // seguimos al fallback
      console.debug('No se pudo compartir como archivos:', e);
    }

    // 4) Fallback: texto con títulos y links (WhatsApp Web / iOS / desktop)
    const text = buildMessage(title, media);
    if (navigator.share) {
      try {
        await navigator.share({ title, text });
        return;
      } catch(_) { /* usuario canceló o no disponible */ }
    }
    // Abrir WhatsApp con el texto
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer');
  }

  // Delegación de eventos (soporta quick-view dinámico)
  document.addEventListener('click', handleShare, { capture: true });
  document.addEventListener('pointerup', handleShare, { capture: true });
  document.addEventListener('touchend', handleShare, { capture: true, passive: false });
})();
